import type { GridApi } from '@mui/x-data-grid-pro';
import type React from 'react';

export function expandAncestorsForTargets(
  apiRef: React.RefObject<GridApi>,
  targetIds: number[],
): Array<string | number> {
  const api = apiRef.current;
  if (!api) return [];

  const visitedAncestorIds = new Set<string | number>();
  const collapsedAncestorIds = new Set<string | number>();
  for (const targetId of targetIds) {
    const node = api.getRowNode(targetId);
    if (!node) continue;
    let cursor = node.parent != null ? api.getRowNode(node.parent) : null;
    while (cursor && cursor.type === 'group' && !visitedAncestorIds.has(cursor.id)) {
      visitedAncestorIds.add(cursor.id);
      if (!cursor.childrenExpanded) collapsedAncestorIds.add(cursor.id);
      cursor = cursor.parent != null ? api.getRowNode(cursor.parent) : null;
    }
  }

  for (const ancestorId of collapsedAncestorIds) {
    api.setRowChildrenExpansion(ancestorId, true);
  }

  return [...collapsedAncestorIds];
}

export function expandAncestors(
  apiRef: React.RefObject<GridApi>,
  targetId: number,
): { found: boolean; expandedAny: boolean } {
  const api = apiRef.current;
  if (!api) return { found: false, expandedAny: false };

  const node = api.getRowNode(targetId);
  if (!node) return { found: false, expandedAny: false };

  const expandedIds = expandAncestorsForTargets(apiRef, [targetId]);
  return { found: true, expandedAny: expandedIds.length > 0 };
}
